module.exports = __webpack_public_path__ + "img/paidStamp.24210b15.png";